export enum PatientInsuranceType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  NOT_SELECTED = 'NOT_SELECTED'
}